import { TradingRelationship, Status, MasterLegalAgreementType } from 'api'

export function hasTradingRelationship(
  fundId: string,
  counterpartyId: string,
  relationships: TradingRelationship[],
  checkUsSponsoredClearing: boolean,
  masterLegalAgreementTypes: MasterLegalAgreementType[]
): boolean {
  return relationships.some(
    relationship =>
      relationship.buyTradingEntity === fundId &&
      relationship.sellTradingEntity === counterpartyId &&
      (!checkUsSponsoredClearing || relationship.usSponsoredClearing) &&
      relationship.status === Status.APPROVED &&
      (!masterLegalAgreementTypes ||
        relationship.masterLegalAgreements.length === 0 ||
        masterLegalAgreementTypes.every(masterLegalAgreementType => relationship.masterLegalAgreements.includes(masterLegalAgreementType)))
  )
}
